import { useEffect } from "react";

const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://example.com";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "HealthAndBeautyBusiness",
  name: "KUU",
  alternateName: "ウェルネスサロン KUU",
  description:
    "鎌倉の自然の中で、体と心を整えるウェルネスサロン。ボディ・フェイス・ヘッドの本格トリートメントを提供。",
  url: siteUrl,
  telephone: "0467-XX-XXXX",
  address: {
    "@type": "PostalAddress",
    streetAddress: "由比ヶ浜2-X-X",
    addressLocality: "鎌倉市",
    addressRegion: "神奈川県",
    postalCode: "248-0014",
    addressCountry: "JP",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 35.3197,
    longitude: 139.5502,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Wednesday", "Thursday", "Friday"],
      opens: "10:00",
      closes: "19:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Saturday", "Sunday", "PublicHolidays"],
      opens: "09:00",
      closes: "18:00",
    },
  ],
  sameAs: [],
  hasMap: "https://www.google.com/maps/search/?api=1&query=鎌倉市由比ヶ浜",
  priceRange: "¥¥",
  currenciesAccepted: "JPY",
  paymentAccepted: "現金, クレジットカード, PayPay, LINE Pay",
  image: `${siteUrl}/og-image.jpg`,
  "@id": `${siteUrl}/#localbusiness`,
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "予約はどのようにすればいいですか？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "このページ下部の予約フォーム、またはLINE公式アカウントからご予約いただけます。ご希望の日時と施術内容をお知らせください。折り返しご連絡いたします。",
      },
    },
    {
      "@type": "Question",
      name: "初めてでも大丈夫ですか？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "もちろんです。初回はカウンセリングの時間を設けており、体の状態やご希望を丁寧にお伺いした上で施術内容をご提案します。不安なことがあればお気軽にご質問ください。",
      },
    },
    {
      "@type": "Question",
      name: "当日キャンセルはできますか？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "前日までのキャンセルは無料です。当日キャンセルは施術料金の50%をキャンセル料としていただく場合がございます。体調不良の場合はご相談ください。",
      },
    },
    {
      "@type": "Question",
      name: "妊娠中でも施術を受けられますか？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "安定期（16週以降）の方は施術可能です。ただし、ご体調や医師の判断によって対応が異なる場合があります。ご予約の際にお知らせください。",
      },
    },
    {
      "@type": "Question",
      name: "駐車場はありますか？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "サロン近隣にコインパーキングがございます（徒歩2分）。電車でのご来店が便利です。最寄り駅はJR鎌倉駅より徒歩10分です。",
      },
    },
    {
      "@type": "Question",
      name: "支払い方法は何が使えますか？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "現金、クレジットカード（VISA・Mastercard・JCB）、PayPay・LINE Payなどのキャッシュレス決済に対応しています。",
      },
    },
  ],
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  url: siteUrl,
  name: "鎌倉ウェルネスサロン KUU｜ボディ・フェイス・ヘッドトリートメント",
  description:
    "鎌倉由比ヶ浜のウェルネスサロンKUU。ボディ・フェイス・ヘッドの本格トリートメントで心身を整えます。初回カウンセリング付き。JR鎌倉駅徒歩10分。",
  inLanguage: "ja",
  isPartOf: {
    "@type": "WebSite",
    url: siteUrl,
    name: "KUU",
  },
};

function injectJsonLd(id: string, data: object) {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const script = document.createElement("script");
  script.id = id;
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export default function SeoJsonLd() {
  useEffect(() => {
    injectJsonLd("jsonld-local-business", localBusinessSchema);
    injectJsonLd("jsonld-faq", faqSchema);
    injectJsonLd("jsonld-webpage", webPageSchema);

    return () => {
      ["jsonld-local-business", "jsonld-faq", "jsonld-webpage"].forEach((id) => {
        document.getElementById(id)?.remove();
      });
    };
  }, []);

  return null;
}
